import { SVGProps, Ref, forwardRef } from 'react';

export const BankOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.9 18.227c.258.08.484.19.692.34.785.566 1.115 1.556 1.775 3.535L24 24H0l.633-1.898c.618-1.855.947-2.842 1.633-3.424l.142-.112c.208-.15.434-.258.692-.34V8.92H2c-.884 0-1.354 0-1.65-.241l-.057-.052C0 8.334 0 7.863 0 6.92v-2L11.23.24c.38-.158.57-.237.77-.237s.39.08.77.237L24 4.92v2c0 .943 0 1.414-.293 1.707s-.764.293-1.707.293h-1.1zm-16-.217c.414-.01.884-.01 1.424-.01h2.109V8.92H4.9zm1.424 1.79c-1.085 0-1.748.003-2.242.06-.447.05-.569.129-.621.166s-.165.128-.356.537c-.175.378-.35.88-.605 1.637h19c-.254-.757-.43-1.259-.605-1.637-.19-.409-.304-.5-.356-.537s-.174-.116-.621-.167c-.494-.056-1.157-.06-2.242-.06zm5.599-17.898L1.8 6.12v1l.2.001h20l.198-.002.002-.198v-.8L12.077 1.901 12 1.87zM10.233 18h3.534V8.92h-3.534zm5.334 0h2.109l1.382.009h.042V8.92h-3.533z"
                fill="currentColor"
            />
        </g>
    </svg>
));
BankOutlinedSize24Glyph.displayName = 'BankOutlinedSize24Glyph';
